import { AccountSourceEnum } from "@unleashed/models/ThriveScoreCompletion";

/**
 * [ADMIN-102] Placeholder values written to ThriveScoreProvisional accounts (AccountSourceId=2)
 * when they are auto-created from ThriveScore data with missing required fields.
 */
export const PROVISIONAL_PLACEHOLDERS = {
  lastName: "-",
  phone: "000-000-0000",
  dateOfBirth: "1900-01-01",
} as const;

/** True when the account is a ThriveScoreProvisional account (AccountSourceId=2). */
export const isProvisionalAccount = (accountSourceId?: number): boolean =>
  accountSourceId === AccountSourceEnum.ThriveScoreProvisional;

/**
 * Returns the value unless it is a known provisional placeholder on a provisional account,
 * in which case it returns undefined so the UI shows a blank instead of the placeholder.
 * Single-character placeholders (e.g. lastName "-") require an exact match so legitimate
 * values that merely start with the same character (e.g. "-Smith") aren't suppressed.
 */
export const suppressProvisionalPlaceholder = (
  value: string | undefined,
  accountSourceId: number | undefined,
  placeholder: string,
): string | undefined => {
  const trimmed = value?.trim();
  const isMatch =
    placeholder.length === 1 ? trimmed === placeholder : trimmed?.startsWith(placeholder);
  return isProvisionalAccount(accountSourceId) && isMatch ? undefined : value;
};
